import { Fragment, useContext, useState } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { Box, CircularProgress } from "@mui/material";
import { PopoverMenu } from "../../../common";
import AddContactSelector from "../../../common/AddContactSelector";
import { DeleteNewIcon, EditIcon } from "../../../../assets/icons/icon";
import { useAuthContext } from "../../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import SidebarBodyContent from "../../../common/UBRightSidebar/SidebarBodyContent";
import { Sync } from "../../../../SyncService";
import { useSnackbar } from "../../../../context/SnackbarContext";
import withObservables from "@nozbe/with-observables";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { catchError, of } from "rxjs";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import { sentenceCase } from "../../../../constants";
import { dateFormatInNumberWithSpace, resolveCategoryDisplayName } from "../../../../utils";
import styles from "./styles.module.css"
import AttachContactMessage from "../../../common/AttachContactMessage";

const ItemList = ({
  cashTxn,
  index,
  customerDetail,
  contactList = [],
  selectedContactId,
  setSelectedContactId,
  justClosedDropdownRef,
  refetchList = () => { },
  balance = 0,
}) => {
  const [I18n] = useContext(LanguageContext);
  const [openDetailSidebar, setOpenDetailSidebar] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const { user, business } = useAuthContext();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
    setSelectedContactId(null);
  };

  const handleAddCustomer = async (customer) => {
    try {
      await cashTxn.updateCashTxnCustomer(customer);
      setSelectedCustomer("");
      setSelectedContactId("");
      triggerLogEvent(analytics, "cash_book_contact_attached");
      Sync(user.phone_number, navigate);
      showSnackbar({ message: I18n.contact_attached_successfully, severity: "success" });
    } catch (error) {
      console.error(error);
    }
  };

  const menuActions = [
    {
      label: (
        <Fragment>
          <EditIcon width={20} height={20} />
          <ParagraphText id="cash_book_edit_label" className="textCapitalizeFirstLetter">{I18n.edit}</ParagraphText>
        </Fragment>
      ),
      action: (e) => {
        e.stopPropagation();
        triggerLogEvent(analytics, "cash_book_edit");
        navigate(
          cashTxn?.type === "in"
            ? `/Sales/CashBook/CashIn/Edit/${cashTxn.id}`
            : `/Sales/CashBook/CashOut/Edit/${cashTxn.id}`,
        );
      },
    },
    {
      label: (
        <Fragment>
          <DeleteNewIcon width={20} height={18} id="delete_black_btn" />
          <ParagraphText id="cash_book_delete_label" className="textCapitalizeFirstLetter">{I18n.delete}</ParagraphText>
        </Fragment>
      ),
      danger: true,
      action: (e) => {
        e.stopPropagation();
        setShowDeleteModal(true);
      },
    },
  ];

  const handleDelete = async (e) => {
    e.stopPropagation();
    setShowDeleteModal(false);
    setIsActionLoading(true);
    triggerLogEvent(analytics, "cash_book_delete");
    await cashTxn.markAsDeleted();
    refetchList(true);
    setOpenDetailSidebar(false);
    setIsActionLoading(false);
    Sync(user.phone_number, navigate);
    showSnackbar({ message: I18n.transaction_deleted, severity: "success", icon: "" });
  };

  const isMoneyIn = cashTxn?.type === "in";

  const cashTxnForSidebar = {
    ...cashTxn?._raw,
    id: cashTxn?.id,
    customer: cashTxn?.customer,
    status: isMoneyIn ? I18n.cash_in : I18n.cash_out,
    category: cashTxn?.category,
    payment_mode : cashTxn?.method,
    attachment: Array.isArray(cashTxn?.attachment) && cashTxn.attachment.length
      ? cashTxn?.attachment
      : [],
  };

  const customerInfoData = [
          {
            title: I18n.date,
            value: dateFormatInNumberWithSpace(cashTxn?.created_at),
          },
          {
            title: I18n.document_no,
            value: (cashTxn?.invoice_number && cashTxn?.invoice_prefix) ? `${cashTxn?.invoice_prefix?.replace(`#`, " #")}${cashTxn?.invoice_number}` : "-",
          },
          {
            title: I18n.contact,
            value: customerDetail?.name || "-",
          },
          {
            title: I18n.category,
            value: cashTxn?.category
              ? resolveCategoryDisplayName(
                  isMoneyIn ? "cb_cash_in" : "cb_cash_out",
                  cashTxn.category,
                )
              : "-",
          },
          {
            title: I18n.payment_mode,
            // method is stored in English (cash/bank/...); show the translated label when one exists
            value: sentenceCase(I18n[String(cashTxn?.method || "").toLowerCase()] || cashTxn?.method) || "-",
          },
          {
            title: I18n.notes,
            value: cashTxn?.note || "-",
            className : styles.sideBarNoteItem
          },
        ];
  return (
    <Box
      id={`cash_book_list_${index}`}
      className="invoiceListTableBody AccountItemListWrapper"
      onClick={(e) => {
        if (showDeleteModal || selectedCustomer || openDetailSidebar || justClosedDropdownRef?.current) return;
        e.stopPropagation();
        if (selectedContactId) {
          setSelectedContactId("");
          return;
        }
        setOpenDetailSidebar(true);
        triggerLogEvent(analytics, "cash_book_detail");
      }}
    >
      <Box id={`cash_book_row_date_${index}`} className="invListTableHeaderCol eightColumn textLeft sidebarOption">
        <ParagraphText id={`cash_book_row_date_value_${index}`} className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {dateFormatInNumberWithSpace(cashTxn?.transacted_at)}
        </ParagraphText>
      </Box>

      <Box id={`cash_book_row_contact_${index}`} className="invListTableHeaderCol eightColumn textLeft">
        <AddContactSelector
          selectedContact={customerDetail?.name ? { id: customerDetail.id, name: customerDetail.name } : null}
          contacts={contactList}
          isOpen={selectedContactId === cashTxn?.id}
          onOpenChange={(open) => {
            if (!customerDetail && !selectedContactId) {
              setSelectedContactId(open ? cashTxn.id : "");
            } else if (selectedContactId) {
              justClosedDropdownRef.current = true;
              setSelectedContactId("");
              setTimeout(() => { justClosedDropdownRef.current = false; }, 100);
            } else if (!selectedContactId && !justClosedDropdownRef.current) {
              setOpenDetailSidebar(true);
            }
          }}
          onSelect={handleSelectCustomer}
          addContactLabel={I18n.add_contact || "Add contact"}
          searchPlaceholder={I18n.search_contact || "Search contact"}
        />
      </Box>

      <Box id={`cash_book_row_document_no_${index}`} className="invListTableHeaderCol eightColumn textLeft">
        <ParagraphText id={`cash_book_row_document_no_value_${index}`} className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {cashTxn?.invoice_number
            ? `${(cashTxn.invoice_prefix || "").replace("#", "")} #${cashTxn.invoice_number}`
            : "-"}
        </ParagraphText>
      </Box>

      <Box id={`cash_book_row_type_${index}`} className="invListTableHeaderCol eightColumn textLeft">
        <ParagraphText id={`cash_book_row_type_value_${index}`} className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {isMoneyIn ? I18n.cash_in : I18n.cash_out}
        </ParagraphText>
      </Box>

      <Box id={`cash_book_row_category_${index}`} className="invListTableHeaderCol eightColumn textLeft">
        <ParagraphText id={`cash_book_row_category_value_${index}`} className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {cashTxn?.category
            ? resolveCategoryDisplayName(
                isMoneyIn ? "cb_cash_in" : "cb_cash_out",
                cashTxn.category,
              )
            : "-"}
        </ParagraphText>
      </Box>

      <Box id={`cash_book_row_amount_${index}`} className="invListTableHeaderCol eightColumn textRight amountColumnNewWrapper">
        <ParagraphText id={`cash_book_row_amount_value_${index}`} className={`fontSize14 fontWeight400 truncateOneLine textRight ${isMoneyIn ? "foundationGreenColor" : "newFontColor"}`}>
          {isMoneyIn ? "+" : "-"}Rs. {formatNum(Math.abs(cashTxn?.amount) || 0)}
        </ParagraphText>
      </Box>

      <Box id={`cash_book_row_balance_${index}`} className="invListTableHeaderCol eightColumn textRight">
        <ParagraphText id={`cash_book_row_balance_value_${index}`} className="fontSize14 fontWeight400 truncateOneLine textRight newFontColor">
          Rs. {formatNum(balance)}
        </ParagraphText>
      </Box>

      <Box id={`cash_book_row_actions_${index}`} className="amountColumnInnerWrapper invListTableHeaderCol eightColumn textCenter">
        <ParagraphText id={`cash_book_row_actions_content_${index}`} className="fontSize14 fontWeight400 textCenter newFontColor tableActionsCell">
          <div className="tblOptnBox" role="button">
            <PopoverMenu
              id="cash_book"
              menuOptions={menuActions}
              popOverStyle={{ marginLeft: "5px", borderRadius: "16px !important" }}
              popoverButton={isActionLoading && <CircularProgress size="15px" />}
              disabled={isActionLoading}
            />
          </div>
        </ParagraphText>
      </Box>

      {openDetailSidebar && (
        <SidebarBodyContent
          onClose={() => setOpenDetailSidebar(false)}
          open={openDetailSidebar}
          customerInfoData={customerInfoData}
          quickSale={cashTxnForSidebar}
          refetchList={refetchList}
          business={business}
          handleDelete={() => setShowDeleteModal(true)}
          handleEdit={() => {
            triggerLogEvent(analytics, "cash_book_sidebar_edit")
            navigate(
              cashTxn?.type === "in"
                ? `/Sales/CashBook/CashIn/Edit/${cashTxn.id}`
                : `/Sales/CashBook/CashOut/Edit/${cashTxn.id}`,
            )
          }
          }
          hideReceiptActions
          isShowInvoiceDownload={false}
          unpaidAmountVariant={isMoneyIn ? "expense" : "cashbook"}
        />
      )}

      {showDeleteModal && (
        <ConfirmationModal
          open={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleDelete}
          title={I18n.this_action_cannot_be_undone}
          message={I18n.are_you_sure_you_want_to_delete_transaction}
          confirmText={I18n.delete}
          id="cash_book_delete_modal"
        />
      )}

      {selectedCustomer && (
        <ConfirmationModal
          open={Boolean(selectedCustomer)}
          onClose={() => setSelectedCustomer("")}
          onConfirm={() => handleAddCustomer(selectedCustomer)}
          confirmButtonClassName="ubPrimaryButton"
          title={I18n.you_wont_be_able_to_change_it_later}
          htmlMessage={
            <AttachContactMessage id="cash_book_contact_confirm_message" name={selectedCustomer.name} />
          }
          confirmText={I18n.confirm}
          id="cash_book_add_contact_confirm_modal"
        />
      )}
    </Box>
  );
};

const enhance = withObservables(["cashTxn"], ({ cashTxn }) => ({
  customerDetail: cashTxn?.customer
    ? cashTxn.customer.observe().pipe(catchError(() => of(null)))
    : of(null),
}));

export default enhance(ItemList);
